import reqEnum from '../../utils/request-statuses';

export const getEvents = state => state.sessionReports.events;
export const eventsStatus = state => state.sessionReports.status;
export const eventsLoadingInProgress = state => state.sessionReports.status === reqEnum.loading;
export const eventsError = state => state.sessionReports.error;
export const getPager = state => state.sessionReports.pager;